import React from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { PageError } from 'src/pages/error';
import { registerError } from 'src/state/errors/errors-slice';

interface State {
  hasError: boolean;
}

const mapDispatchToProps = {
  registerError,
};

const connector = connect(null, mapDispatchToProps);

type Props = ConnectedProps<typeof connector> & { children: React.ReactNode };

class ErrorBoundaryComponent extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.registerError(error);
    // eslint-disable-next-line no-console
    console.warn('React component stack:', errorInfo.componentStack);
  }

  public render(): React.ReactNode {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return <PageError />;
    }

    return children;
  }
}

const ErrorBoundary = connector(ErrorBoundaryComponent);

export { ErrorBoundary };
